<template>
  <div class="blogs">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for>Blog Ara</label>
          <div class="input-group">
            <input
              class="form-control custom-input"
              type="text"
              placeholder="Blog Başlığı"
              v-model="search"
            >
            <span class="input-group-btn">
              <a class="btn btn-primary" style="height: 45px;" @click="searchFilter">
                <i class="fa fa-search" style="vertical-align: -webkit-baseline-middle;"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for>Kategori</label>
          <select class="form-control custom-input" v-model="category" @change="categoryFilter">
            <option value selected hidden disabled>Seçiniz...</option>
            <option
              v-for="category in categories"
              :key="category.id"
              :value="category.id"
            >{{ category.title }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="table-area">
            <div class="widget-title">
              <h3>
                <i :class="icon"></i>
                {{ tableName }}
              </h3>
              <span>{{ tableDesc }}</span>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Başlık</th>
                    <th>Kategori</th>
                    <th>Görüntülenme</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>{{ item.title }}</td>
                    <td v-if="item.category">{{ item.category.title }}</td>
                    <td v-else>Yok</td>
                    <td>{{ item.view_count }}</td>
                    <td>
                      <router-link
                        :to="{ name: 'blogs.update', params: {id: item.id} }"
                        class="btn btn-primary btn-xs"
                      >

                        <span>Düzenle</span>
                      </router-link>/
                      <button class="btn btn-danger btn-xs" @click="destroy(item)">
                       Sil
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableName: "Blog Tablosu",
      icon: "fa fa-rss",
      tableDesc: "",
      api: "blogs/",
      items: [],
      category: "",
      categories: [],
      search: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$Progress.start();
      this.axios.get(this.api).then(response => {
        (this.items = response.data.blogs),
          (this.categories = response.data.blogCategories);
        this.$Progress.finish();
      });
    },
    searchFilter() {
      this.$Progress.start();
      this.axios
        .get(this.api, {
          params: {
            title: this.search
          }
        })
        .then(response => {
          this.items = response.data.data.data;
          this.pagination = response.data.pagination;
          this.$Progress.finish();
        });
    },
    categoryFilter() {
      this.$Progress.start();
      this.axios
        .get(this.api, {
          params: {
            category: this.category
          }
        })
        .then(response => {
          this.items = response.data.data.data;
          this.pagination = response.data.pagination;
          this.$Progress.finish();
        });
    },
    destroy(item) {
      this.$swal({
        title: "Silmek istediğinizden emin misiniz?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "İptal"
      }).then(result => {
        if (result.value) {
          this.axios.delete(this.api + item.id).then(response => {
            if (response.status == 200) {
              this.$swal("Başarılı!", "Veri silme işlemi başarılı", "success");
              this.items.splice(this.items.indexOf(item), 1);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
